import { render } from "./LabPrint1View.vue?vue&type=template&id=4aefbf13&scoped=true"
import script from "./LabPrint1View.vue?vue&type=script&lang=js"
export * from "./LabPrint1View.vue?vue&type=script&lang=js"

import "./LabPrint1View.vue?vue&type=style&index=0&id=4aefbf13&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aefbf13"]])

export default __exports__